<div class="bi-incapsulation">
  <app-dashboard [inputDashboard]="dashboard$ | async" [standalone]="true"></app-dashboard>
</div>
